module.exports = __webpack_public_path__ + "img/iso1328-1-2013_fig13_helix-deviation-lead-slope-end-relief.f955ac74.png";